import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'
import AuthorisationHandler from '../components/AuthorisationHandler'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import Select from 'react-select'
import { create_experience as create_experience_request, update_experience_image } from '../api'
import shortid from 'shortid'

import Page from './Page'
import Input from '../components/Input'
import Map from '../components/Map'
import SearchLocation from '../components/SearchLocation'
import EventList from '../components/CreateExperienceEvents'
import Loading from '../components/Loading'
import object_value from '../api/object_value'
import return_html from '../api/return_html'

const LAT = 52.5200 //55.751244
const LNG = 13.4050 //37.618423

@inject('user', 'create_experience', 'cities', 'categories', 'payment_methods')
@observer
class CreateExperiencePage extends Component {
  constructor (props, context) {
    super(props, context)
    // Initial state of <Select> components
    this.state = {
      status: null,
      form_data: new FormData(),
      step: 1,
      steps: [
        'Sprache',
        'Stadt',
        'Erlebnis',
        'Veröffentlichung'
      ],
      language: '',
      city_id: '',
      category_id: '',
      payment_methods_id: '',
      payment_email: '',
      account_owner: '',
      iban: '',
      imagePreviewUrl: '',
      latLng: {lat: LAT, lng: LNG},
      address: '',
      latitude: LAT,
      longitude: LNG,
      events: [],
        // {
        //   date: new Date().toISOString().split('.')[0] + 'Z'
        // }],
      duration: 0,
      created_id: null
    }
    this.baseState = this.state

    this.language_options = [
      {value: 'en', label: 'Englisch'},
      {value: 'de', label: 'Deutsch'}
    ]

    props.categories.get()
    // TODO: Make token optional
    const {token} = props.user
    if (token) {
      props.cities.get(token)
      props.payment_methods.get(token)
    }
  }

  componentDidMount() {
    // Force first step append
    // this.state.form_data.append('language', 'en')
  }

  resetForm = () => {
    this.setState(this.baseState)
  }

  stepIsDisabled = (step) => {
    let {state} = this
    const {create_experience} = this.props
    const {events_dates, duration} = create_experience

    step = parseInt(step)
    let step_1 = !state.language
    let step_2 = step_1
      || !state.city_id
      || !state.address
    let step_3 = step_2
      || !state.image
      || !state.title
      || !state.description
      || !state.category_id
      || !Array.isArray(events_dates)
      || events_dates.length < 1
      || duration < 0
      || !state.number_guests
      || !state.price
      || !state.comment
    let step_4 = step_3
      || !state.payment_methods_id
      || (state.payment_methods_id === 1 && !state.payment_email)
      || (state.payment_methods_id === 2 && (!state.account_owner || !state.iban))

    if (step === 1) {
      return step_1
    }

    if (step === 2) {
      return step_2
    }

    if (step === 3) {
      return step_3
    }

    if (step === 4) {
      return step_4
    }

    return true
  }

  handleChangeLocation = async ({address, latLng}) => {
    console.log('CreateExperiencePage.js - handleChangeLocation', address, latLng)
    await this.setState({
      address,
      latLng,
      latitude: latLng.lat,
      longitude: latLng.lng
    })
    const event = new Event('change')
    event.name = 'location'
    event.value = address
    await this.handleInputChange(event)
  }

  handleStepChange = async (step) => {
    await this.setState({step})
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    console.log('CreateExperiencePage.js - handleSubmit()', event)

    const data = new FormData(event.target)
    // Display the key/value pairs
    console.log('CreateExperiencePage.js - handleSubmit() - data')
    for (let [key, val] of data.entries()) {
      console.log(key, val)
      // Append current <form> values
      this.state.form_data.append(key, val)
    }

    console.log('CreateExperiencePage.js - handleSubmit() - step', this.state.step,
      this.state.steps.length)
    if (this.state.step < this.state.steps.length) {
      this.setState({step: this.state.step + 1})
      return
    }
    // On last step use accumulated data from all forms
    const formData = this.state.form_data

    // Detach and keep image
    const image = formData.get('image')
    formData.delete('image')
    console.log('CreateExperiencePage.js - handleSubmit() - image', image)

    // Create experience without image
    const {token} = this.props.user

    this.setState({status: 'loading'})

    formData.delete('date')
    const createResult = await create_experience_request(formData, token, {
      // Add events and duration
      events: this.props.create_experience.events_dates,
      duration: this.props.create_experience.duration
    })
    console.log('CreateExperiencePage.js - handleSubmit() - create_result',
      createResult)
    // Add image to experience
    if (createResult.ok) {
      // TODO: Check why server not accept file
      const fileData = new FormData()
      fileData.append('image', image)

      const created_id = createResult.data.id
      const updateResult = await update_experience_image(fileData, token, created_id)
      console.log('CreateExperiencePage.js - handleSubmit() - update_result', updateResult)

      if (updateResult.ok) {
        const id = createResult.data.id
        if (id) {
          // this.props.history.push('/experience/' + id)
          this.setState({
            status: 'success',
            created_id
          })
        }
        this.setState({status: 'success'})
      } else {
        this.setState({
          status: 'error-update',
          created_id,
          status_message: updateResult.data.message
        })
      }
    } else {
      let message = createResult.data.message
      let errors = object_value(createResult, 'data.errors', {})
      if (errors !== null && typeof errors === 'object') {
        for (let [key, value] of Object.entries(errors)) {
          if (value.length > 0) {
            let fetch_text = ''

            value.forEach(t => {
              fetch_text = fetch_text + t + '<br>'
            })

            message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
          }
        }
      }

      this.setState({
        status: 'error',
        status_message: message
      })
    }
  }

  handleInputChange = async (event) => {
    // console.log('CreateExperiencePage.js - handleInputChange() - event', event)
    const target = event.target
    const value = target
      ? (target.type !== 'checkbox'
        ? target.value
        : target.checkbox)
      : event.value
    const name = target
      ? target.name
      : event.name

    console.log('handleInputChange()', name, value)

    this.setState({
      [name]: value
    })

    if (value) {
      // Show preview
      let file = object_value(event, 'target.files.0')

      if (file) {
        let reader = new FileReader()
        reader.onloadend = () => {
          this.setState({
            imagePreviewUrl: reader.result
          })
        }
        reader.readAsDataURL(file)
      }
    } else {
      this.setState({
        imagePreviewUrl: ''
      })
    }
  }

  // Selects
  handleLanguageChange = async ({label, value}) => {
    console.log('language', value, label)
    await this.setState({language: value})
  }
  handleCityIdChange = async ({label, value}) => {
    console.log('city_id', value, label)
    await this.setState({city_id: value})
  }
  handlePaymentMethodsIdChange = async ({label, value}) => {
    console.log('payment_methods_id', value, label)
    await this.setState({payment_methods_id: value})
  }
  handleCategoryIdChange = async ({label, value}) => {
    console.log('category_id', value, label)
    await this.setState({category_id: value})
  }

  render () {
    let instance = this
    const {status} = this.state

    function stepClass (step, baseStyle = '') {
      let isCurrent = instance.state.step === step
      return isCurrent ? baseStyle + ' current' : baseStyle
    }

    if (status === 'error') {
      return (
        <Page title='Create experience'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <p><button className='b-button'
                       onClick={this.resetForm}>Retry</button></p>
            <h3 className='b-info-subtitle'>Error</h3>
            <code dangerouslySetInnerHTML={return_html(this.state.status_message.toString())} />
          </article>
        </Page>
      )
    }

    if (status === 'error-upload') {
      return (
        <Page title='Create experience'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <p>
              <NavLink to={'/experience/' + this.state.created_id}>Das Erlebnis wurde erstellt.</NavLink>,
              but the image has not been uploaded.</p>
            <h3 className='b-info-subtitle'>Error</h3>
            <code dangerouslySetInnerHTML={return_html(this.state.status_message.toString())} />
          </article>
        </Page>
      )
    }

    if (status === 'success') {
      return (
        <Page title='Create experience'>
          <article className='b-info'>
            <h2 className='b-info-title'>{intl.get('create_experience.created_title')}</h2>
            <h3 className='b-info-subtitle'>{intl.get('create_experience.created_message')}</h3>
            <h3 className='b-info-subtitle'><NavLink to={'/experience/' + this.state.created_id}>{intl.get('Open')}</NavLink></h3>
          </article>
        </Page>
      )
    }

    return (
      <AuthorisationHandler check_if_confirmed={true}>
        <Page title='Erlebnis erstellen'>
          {status === 'loading' ? <div><Loading /></div> :
          <section className='b-create-event'>
            <div className='b-create-event-indicator'>
              {this.state.steps.map((name, index) =>
                <div className={stepClass(index + 1, 'b-create-event-indicator-step')}
                     key={shortid.generate()}>
                  <button className={stepClass(index + 1, 'b-create-event-indicator-step-button')}
                          disabled={index > 0 && this.stepIsDisabled(index)}
                          type='button'
                          onClick={() => this.handleStepChange(index + 1)}>
                    <span
                      className='b-create-event-indicator-step-button-label'>{name}</span>
                    <span
                      className='b-create-event-indicator-step-button-index'>{index + 1}</span>
                  </button>
                </div>
              )}
            </div>

            {/* step 1 */}
            <form className={stepClass(1, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-title'>{intl.get('create_experience.language_title')}</h2>
              <div className='b-create-event-text'>{intl.get('create_experience.language_message')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <div className='b-form-item-wrapSelect'>
                    <Select id='language'
                            name='language'
                            placeholder='Wähle eine Sprache aus'
                            value={this.state.language}
                            options={this.language_options}
                            onChange={this.handleLanguageChange}
                            searchable={false}
                            required />
                  </div>
                  {/*
                  <label className='b-form-item-label' htmlFor='language'>
                    Choose a language
                  </label>
                  */}
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                        type='submit'
                        disabled={this.stepIsDisabled(1)}>
                    {intl.get('create_experience.save_and_next')}
                  </button>
                </div>
              </div>
            </form>

            {/* step 2 */}
            <form className={stepClass(2, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-title'>{intl.get('create_experience.location_title')}</h2>
              <div className='b-create-event-text'>{intl.get('create_experience.location_message')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <div className='b-form-item-wrapSelect'>
                    <Select id='city_id'
                            name='city_id'
                            value={this.state.city_id}
                            options={this.props.cities.options}
                            onChange={this.handleCityIdChange}
                            searchable={false}
                            required />
                  </div>
                  <label className='b-form-item-label'
                         htmlFor='city_id'>
                    {intl.get('City')}
                  </label>
                </div>

                <div className='b-form-item b-form-item_x'
                     style={{marginTop: '-0.4rem'}}>
                    <SearchLocation classNames={{
                                      // root: 'form-group',
                                      input: 'b-form-item-input-text', //'form-control',
                                      autocompleteContainer: 'b-form-item-location-autocomplete-container'
                                    }}
                                    googleLogo={false}
                                    onChangeLocation={this.handleChangeLocation} />
                  <Input id='location'
                         name='location'
                         value={this.state.address}
                         type='hidden'
                         onChange={this.handleInputChange}
                         required />
                  <label className='b-form-item-label fixed'
                         htmlFor='location'>
                    {intl.get('Location')}
                  </label>
                </div>
              </div>

              {/*<div className='b-form-h4' style={{marginBottom: '3rem'}}>Setze einen Pin für eine noch genauere Position</div>*/}

              {this.state.step === 2 && <Map center={this.state.latLng} />}

              <input type='hidden' name='latitude'
                     value={this.state.latitude} />
              <input type='hidden' name='longitude'
                     value={this.state.longitude} />

              <div className='b-form-row' style={{marginTop: '1.5rem'}}>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          type='submit'
                          disabled={this.stepIsDisabled(2)}>
                    {intl.get('create_experience.save_and_next')}
                  </button>
                </div>
              </div>
            </form>

            {/* step 3 */}
            <form className={stepClass(3, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-title'>{intl.get('create_experience.experience_details_title')}</h2>
              <div className='b-create-event-text'>{intl.get('create_experience.experience_details_message')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <div className='b-form-item-input-create-experience-image'>
                    <label htmlFor='image'
                           className='b-form-item-input-create-experience-image-button'>
                      {intl.get('create_experience.upload_image')}
                    </label>
                    <input id='image'
                           name='image'
                           type='file'
                           accept='image/*'
                           onChange={this.handleInputChange}
                    />
                  </div>

                  {this.state.imagePreviewUrl &&
                  <div className='b-form-image-preview'
                       style={{backgroundImage: 'url(' + this.state.imagePreviewUrl + ')'}} />}
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='title'
                         name='title'
                         type='text'
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='title'>
                    {intl.get('create_experience.title')}
                  </label>
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input element_type='textarea'
                         className='b-form-item-input-text'
                         id='description'
                         name='description'
                         onChange={this.handleInputChange}
                         required />
                  <label className='b-form-item-label' htmlFor='description'>
                    {intl.get('create_experience.description')}
                  </label>
                </div>
              </div>

              <div className='b-form-h4'>{intl.get('create_experience.set_time')}</div>

              <EventList />

              <div className='b-form-h4'>{intl.get('create_experience.participants')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='number_guests'
                         name='number_guests'
                         type='number'
                         min={0}
                         max={10}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='number_guests'>
                    {intl.get('create_experience.guests_amount')}
                  </label>
                </div>
              </div>

              <div className='b-form-h4'>{intl.get('create_experience.price_title')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='price'
                         name='price'
                         type='number'
                         min={0}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='price'>
                    {intl.get('Price')}
                  </label>
                </div>
              </div>

              <div className='b-form-h4' style={{marginBottom: '3rem'}}>{intl.get('create_experience.category')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <div className='b-form-item-wrapSelect'>
                    <Select id='category_id'
                            name='category_id'
                            value={this.state.category_id}
                            options={this.props.categories.options}
                            onChange={this.handleCategoryIdChange}
                            placeholder={'Bitte wähle eine Kategorie'}
                            searchable={false}
                            required />
                  </div>
                  {/*
                  <label className='b-form-item-label' htmlFor='category'>
                    Category
                  </label>
                  */}
                </div>
              </div>

              <div className='b-form-h4'>{intl.get('create_experience.comment_title')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input element_type='textarea'
                         className='b-form-item-input-text'
                         id='comment'
                         name='comment'
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='comment'>
                    {intl.get('create_experience.comment')}
                  </label>
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          type='submit'
                          disabled={this.stepIsDisabled(3)}>
                    {intl.get('create_experience.save_and_next')}
                  </button>
                </div>
              </div>
            </form>

            {/* step 4 */}
            <form className={stepClass(4, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}
            >
              <h2 className='b-create-event-title'>{intl.get('create_experience.launch_title')}</h2>
              <div className='b-create-event-text'>{intl.get('create_experience.launch_message')}</div>

              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <div className='b-form-item-wrapSelect'>
                    <Select id='payment_methods_id'
                            name='payment_methods_id'
                            value={this.state.payment_methods_id}
                            options={this.props.payment_methods.options}
                            onChange={this.handlePaymentMethodsIdChange}
                            placeholder={'Zahlungsmethode aus'}
                            searchable={false}
                            required />
                  </div>
                  <label className='b-form-item-label'
                         htmlFor='payment_methods_id'>
                    {intl.get('create_experience.payment_method')}
                  </label>
                </div>
              </div>

              {this.state.payment_methods_id === 1 &&
              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='payment_email'
                         name='payment_email'
                         type='email'
                         defaultValue={this.state.payment_email}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='title'>
                    {intl.get('create_experience.payment_email')}
                  </label>
                </div>
              </div>}

              {this.state.payment_methods_id === 2 &&
              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='account_owner'
                         name='account_owner'
                         type='text'
                         defaultValue={this.state.account_owner}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='title'>
                    {intl.get('create_experience.account_owner')}
                  </label>
                </div>
              </div>}

              {this.state.payment_methods_id === 2 &&
              <div className='b-form-row'>
                <div className='b-form-item b-form-item_x'>
                  <Input className='b-form-item-input-text'
                         id='iban'
                         name='iban'
                         type='text'
                         defaultValue={this.state.iban}
                         onChange={this.handleInputChange}
                         required
                  />
                  <label className='b-form-item-label' htmlFor='title'>
                    {intl.get('create_experience.IBAN')}
                  </label>
                </div>
              </div>}

              <div className='b-form-row'>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          type='submit'
                          disabled={this.stepIsDisabled(4)}>
                    {intl.get('Submit')}
                  </button>
                </div>
              </div>
            </form>

          </section>}
        </Page>
      </AuthorisationHandler>
    )
  }
}

CreateExperiencePage.propTypes = {
  user: MobxPropTypes.observableObject,
  create_experience: MobxPropTypes.observableObject,
  cities: MobxPropTypes.observableObject,
  categories: MobxPropTypes.observableObject,
  payment_methods: MobxPropTypes.observableObject,
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject
}

export default CreateExperiencePage



// WEBPACK FOOTER //
// ./src/containers/CreateExperiencePage.js